import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    gap: theme.spacings.s,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  variants: {
    active: {
      false: {
        pointerEvents: "none",
      },
    },
  },
});

export const searchButtonStyle = style({
  marginTop: theme.spacings.xs,
});

export const scrollContentStyle = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    paddingRight: theme.spacings.m,
    paddingBottom: theme.spacings.l,
  },
  variants: {
    variant: {
      default: {
        paddingLeft: theme.spacings.m,
      },
      compact: {},
      sideContent: {},
    },
    gap: {
      true: {
        gap: theme.spacings.m,
      },
    },
  },
});

export const noChatMessageStyle = style({
  paddingTop: theme.spacings.xs,
});
